import { CheckoutState } from '../../state';

export const getPaypalScriptStatus = (state: CheckoutState) =>
    state.paypal.scriptStatus;

export const getIsMakingPaypalPayment = (state: CheckoutState) =>
    state.paypal.isMakingPaypalPayment;
